import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/Card';
export function Dashboard() {
  return <div className="space-y-6" data-id="element-436">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-437">Order Info</h1>

      <p className="text-slate-600" data-id="element-438">
        Below is information about the new orders placed by your customers this
        month/this week/today or since your last log in to the administrator
        area.
      </p>

      <Card data-id="element-439">
        <CardContent className="p-0" data-id="element-440">
          <div className="overflow-x-auto" data-id="element-441">
            <table className="w-full text-sm text-left" data-id="element-442">
              <thead className="bg-slate-800 text-white" data-id="element-443">
                <tr data-id="element-444">
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-445">
                    Status
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-446">
                    Since Last Login
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-447">
                    Today
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700 border-r border-slate-700 last:border-r-0" data-id="element-448">
                    This Week
                  </th>
                  <th className="px-6 py-4 font-medium border-b border-slate-700" data-id="element-449">
                    This Month
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-450">
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-451">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-452">
                    Processed
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-453">
                    34
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-454">
                    20
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-455">
                    66
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-456">189</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-457">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-458">
                    Failed/Declined
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-459">
                    2
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-460">
                    1
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-461">
                    3
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-462">10</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-463">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-464">
                    Not Finished
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-465">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-466">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-467">
                    0
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-468">0</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors" data-id="element-469">
                  <td className="px-6 py-4 text-slate-900 border-r border-slate-200" data-id="element-470">
                    Total Paid
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-471">
                    $1325.24
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-472">
                    $724.58
                  </td>
                  <td className="px-6 py-4 text-slate-600 border-r border-slate-200" data-id="element-473">
                    $3078.7
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-474">$9063.84</td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>

      <div data-id="element-475">
        <Link to="/orders" className="text-blue-600 hover:text-blue-800 hover:underline text-sm font-medium" data-id="element-476">
          Order Search
        </Link>
      </div>
    </div>;
}